/**
 * AdminImpersonateRpcClient - AtomRpc integration for admin impersonation.
 *
 * Backs the "Sign in as user" feature: `admin/impersonate/start` mints a Clerk
 * actor token for the target person and returns the URL the browser navigates
 * to in order to establish the impersonated session. Requires admin
 * authentication via the Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminImpersonateRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminImpersonateRpcClient extends AtomRpc.Tag<AdminImpersonateRpcClient>()(
  "AdminImpersonateRpcClient",
  {
    group: AdminImpersonateRpcs,
    protocol: makeRpcClientLayer(AdminImpersonateRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
